/* cart-drawer.js · el carrito en un panel (home v7.1, bloque C).
   Marcado, reglas y por qué las líneas no se pintan tal cual llegan de
   /cart.js: `snippets/cart-drawer.liquid`. Estilos: `assets/base.css`,
   «Carrito en drawer».

   · Lo abre el enlace «Cart (N)» del header (`[data-cart-open]`). Sin JS, o
     con una tecla modificadora (nueva pestaña), el enlace va a /cart.
   · Al abrir: pinta lo que el servidor escribió al pintar la página (el
     mapa lleva la cantidad) y vuelve a pedir /cart.js; con la respuesta
     rehace las líneas y los dos contadores (el del panel y el del header).
   · Cierra con Esc, con el velo y con «Close». El foco entra en el panel, no
     sale de él con Tab y vuelve al enlace al cerrar. `aria-modal` en el
     panel.
   · Sin animación (regla 6: la lista de efectos es cerrada) y sin escuchar
     `scroll`. Con el panel abierto el fondo no se desplaza y al cerrar
     vuelve a donde estaba (v7.2, carril C: `lock`/`unlock`).
   · Si /cart.js falla, el panel se queda con lo que tenía, lo marca con
     `data-cart-stale` y el error se registra en la consola: no se descarta
     (regla 12). */
(function (d, w) {
  var root = d.querySelector('[data-cart-drawer]');
  if (!root || !w.fetch) return;

  var panel = root.querySelector('[role="dialog"]');
  var list = root.querySelector('[data-cart-lines]');
  var empty = root.querySelector('[data-cart-empty]');
  var tpl = root.querySelector('template[data-cart-line]');
  var counts = function () { return d.querySelectorAll('[data-cart-count], .site-tools__count'); };
  /* Lo que el servidor deja enseñar de cada línea (ver el snippet). */
  var map = {};
  var known = root.querySelector('template[data-cart-known]');
  if (known) {
    known.content.querySelectorAll('[data-variant]').forEach(function (el) {
      map[el.dataset.variant] = {
        id: el.dataset.id, name: el.dataset.name, image: el.dataset.image,
        price: el.dataset.price, quantity: +el.dataset.quantity || 0
      };
    });
  }

  /* El fondo quieto (v7.2, carril C): `is-cart-locked` pone `overflow:
     hidden` en <html> y le da al <body> el ancho de la barra de
     desplazamiento que desaparece, para que nada se mueva de lado. Al cerrar
     se quita y la página vuelve a la posición guardada, sin animación. */
  var html = d.documentElement;
  var savedY = 0;
  function lock() {
    savedY = w.scrollY;
    html.style.setProperty('--as-cart-gutter', (w.innerWidth - html.clientWidth) + 'px');
    html.classList.add('is-cart-locked');
  }
  function unlock() {
    html.classList.remove('is-cart-locked');
    html.style.removeProperty('--as-cart-gutter');
    w.scrollTo({ top: savedY, left: 0, behavior: 'instant' });
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var opener = null;

  /* El precio llega con las entidades numéricas de `unit` como texto
     (el snippet lo escapa entero). Aquí pasan a caracteres; el resultado va
     a textContent. */
  function chars(s) {
    return String(s || '').replace(/&#(\d+);/g, function (_, n) { return String.fromCharCode(+n); });
  }

  function setCount(n) {
    counts().forEach(function (el) {
      /* El del header, solo con artículos (S2, feat/capture): vacío, nada. */
      el.textContent = el.classList.contains('site-tools__count') ? (n > 0 ? '(' + n + ')' : '') : String(n);
    });
  }

  /* Una línea de /cart.js → una fila. De /cart.js solo se usan la variante
     (para buscarla en el mapa) y la cantidad; lo que se enseña es del mapa. */
  function row(item) {
    var safe = map[String(item.variant_id)] || {};
    var li = tpl.content.firstElementChild.cloneNode(true);
    var img = li.querySelector('.cart-line__img');
    if (safe.image) {
      img.src = safe.image;
      img.hidden = false;
    } else {
      img.remove();
    }
    li.querySelector('.cart-line__id').textContent = safe.id || 'AS-————';
    li.querySelector('.cart-line__name').textContent = safe.name || '';
    li.querySelector('.cart-line__qty').textContent = 'Qty ' + item.quantity;
    li.querySelector('.cart-line__price').textContent = safe.price ? ' · ' + chars(safe.price) : '';
    return li;
  }

  function paint(items, count) {
    painted = true;
    list.replaceChildren.apply(list, items.map(row));
    empty.hidden = count > 0;
    setCount(count);
  }

  function refresh() {
    return w.fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('/cart.js ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        root.removeAttribute('data-cart-stale');
        paint(cart.items || [], cart.item_count || 0);
      })
      .catch(function (err) {
        root.setAttribute('data-cart-stale', '');
        console.error('cart-drawer: could not refresh from /cart.js', err);
      });
  }

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return !el.hidden && el.getClientRects().length > 0;
    });
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (d.activeElement === first || d.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(from) {
    paintKnown();
    opener = from || d.activeElement;
    lock();
    root.hidden = false;
    if (opener && opener.setAttribute) opener.setAttribute('aria-expanded', 'true');
    d.addEventListener('keydown', onKey);
    var close_ = root.querySelector('.cart-drawer__close');
    (close_ || panel).focus();
    return refresh();
  }

  function close() {
    if (root.hidden) return;
    root.hidden = true;
    unlock();
    d.removeEventListener('keydown', onKey);
    if (opener && opener.setAttribute) opener.setAttribute('aria-expanded', 'false');
    /* Sin desplazar: la página ya está donde estaba (`unlock`). */
    if (opener && opener.focus) opener.focus({ preventScroll: true });
    opener = null;
  }

  /* Lo que el servidor sabía al pintar la página, para no abrir en blanco. */
  var painted = false;
  function paintKnown() {
    if (painted) return;
    painted = true;
    var known = Object.keys(map).map(function (k) { return { variant_id: k, quantity: map[k].quantity }; });
    list.replaceChildren.apply(list, known.map(row));
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) close();
  });

  d.querySelectorAll('[data-cart-open]').forEach(function (a) {
    a.setAttribute('aria-controls', 'cart-drawer');
    a.setAttribute('aria-expanded', 'false');
    a.setAttribute('aria-haspopup', 'dialog');
    a.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      open(a);
    });
  });

  w.acaciasupplies = w.acaciasupplies || {};
  w.acaciasupplies.cartDrawer = { open: open, close: close, refresh: refresh };
})(document, window);
